import { c as _c } from "react/compiler-runtime";
import { ReactNode, useState } from 'react';
import { IconContext } from 'react-icons';
import { QuestionAttachments } from 'shared/forecast/question';
import { mapEntries, notNullOrEmpty } from 'shared/collection';
import { notNull, type Json } from 'shared/type';
import { PiFileFill, PiFilePdfFill } from 'react-icons/pi';
import { match } from 'ts-pattern';
import { HiCheck, HiPaperClip, HiPencil, HiTrash, HiX } from 'react-icons/hi';
import { useUpload } from 'components/hooks/useUpload';
import { ActionIcon, Indicator, Menu, Popover, TextInput, Tooltip } from '@mantine/core';
import { openConfirmModal } from '@mantine/modals';
import { OverflowMenu } from 'components/Menu';
import { DbFormSubset } from 'components/hooks/useDbForm';
import { isArray, isString, pick, mapToObj } from 'remeda';
import { Dropzone, PDF_MIME_TYPE, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import { BsClipboardCheckFill, BsClipboardPlusFill, BsClipboardXFill } from 'react-icons/bs';
import { twMerge } from 'tailwind-merge';
type Attachment = {
  path: string;
  type: string;
  name: string | ReactNode;
};
export const attachmentItems = (cfg: QuestionAttachments | undefined) => mapEntries(cfg ?? {}, (path, a) => a ? {
  path,
  ...a
} : undefined).filter(notNull);
export const AttachmentButton = t0 => {
  const $ = _c(61);
  const {
    form
  } = t0;
  const [opened, setOpened] = useState(false);
  const {
    uploads,
    uploading
  } = useUpload();
  let T0;
  let T1;
  let t1;
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== form.setFieldValue || $[1] !== form.values || $[2] !== opened) {
    const attachments = attachmentItems(form.values);
    T1 = Popover;
    t4 = opened;
    t5 = setOpened;
    t6 = "bottom-end";
    t7 = true;
    t8 = "md";
    t9 = false;
    t10 = true;
    const t12 = attachments.length;
    const t13 = attachments.length == 0 && "invisible";
    let t14;
    if ($[16] !== t13) {
      t14 = twMerge("pointer-events-none text-xs font-extrabold", t13);
      $[16] = t13;
      $[17] = t14;
    } else {
      t14 = $[17];
    }
    let t15;
    if ($[18] !== t14) {
      t15 = {
        indicator: t14
      };
      $[18] = t14;
      $[19] = t15;
    } else {
      t15 = $[19];
    }
    let t16;
    if ($[20] !== opened) {
      t16 = () => setOpened(!opened);
      $[20] = opened;
      $[21] = t16;
    } else {
      t16 = $[21];
    }
    let t17;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <HiPaperClip size="1.1em" />;
      $[22] = t17;
    } else {
      t17 = $[22];
    }
    let t18;
    if ($[23] !== t16) {
      t18 = <ActionIcon variant="subtle" color="gray" onClick={t16}>{t17}</ActionIcon>;
      $[23] = t16;
      $[24] = t18;
    } else {
      t18 = $[24];
    }
    const t19 = <Tooltip label="Add or edit attachments"><Indicator label={t12} size={13} offset={4} color="primary" position="bottom-end" classNames={t15}>{t18}</Indicator></Tooltip>;
    if ($[25] !== t19) {
      t11 = <Popover.Target>{t19}</Popover.Target>;
      $[25] = t19;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    T0 = Popover.Dropdown;
    t1 = "space-y-3 min-w-[30em] max-w-[calc(100vw-4em)]";
    let t20;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <h4 className="font-semibold">Attachments</h4>;
      $[27] = t20;
    } else {
      t20 = $[27];
    }
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex justify-between items-center">{t20}<ActionIcon variant="subtle" size="sm" onClick={() => setOpened(false)}><HiX /></ActionIcon></div>;
      $[28] = t2;
    } else {
      t2 = $[28];
    }
    t3 = notNullOrEmpty(attachments) && <div className="flex flex-col gap-2"><div className="text-sm text-gray-600">Existing attachments:</div><QuestionAttachmentList attachments={attachments} setFieldValue={form.setFieldValue} /></div>;
    $[0] = form.setFieldValue;
    $[1] = form.values;
    $[2] = opened;
    $[3] = T0;
    $[4] = T1;
    $[5] = t1;
    $[6] = t10;
    $[7] = t11;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    T0 = $[3];
    T1 = $[4];
    t1 = $[5];
    t10 = $[6];
    t11 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t12;
  if ($[29] !== form || $[30] !== uploads) {
    t12 = async files => {
      const res = await uploads(files).then(_temp2);
      const newAttachments = mapToObj(res, _temp3);
      form.setValues(newAttachments);
    };
    $[29] = form;
    $[30] = uploads;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = [...IMAGE_MIME_TYPE, ...PDF_MIME_TYPE];
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      root: "flex justify-center items-center w-full p-2 !rounded-lg",
      inner: "pointer-events-none flex items-center gap-4"
    };
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      size: "2em"
    };
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Dropzone.Accept><BsClipboardCheckFill style={{
        color: "var(--mantine-color-primary-filled)"
      }} /></Dropzone.Accept>;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Dropzone.Reject><BsClipboardXFill style={{
        color: "var(--mantine-color-red-7)"
      }} /></Dropzone.Reject>;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <IconContext.Provider value={t15}>{t16}{t17}<Dropzone.Idle><BsClipboardPlusFill style={{
          color: "var(--mantine-color-dimmed)",
          opacity: 0.2
        }} /></Dropzone.Idle></IconContext.Provider>;
    t19 = <div className="text-gray-500/50 text-sm font-medium">Drag files here or click to select</div>;
    $[37] = t18;
    $[38] = t19;
  } else {
    t18 = $[37];
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t12 || $[40] !== uploading) {
    t20 = <Dropzone loading={uploading} onDrop={t12} accept={t13} color="gray.5" classNames={t14}>{t18}{t19}</Dropzone>;
    $[39] = t12;
    $[40] = uploading;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t1 || $[43] !== t2 || $[44] !== t20 || $[45] !== t3) {
    t21 = <div className={t1}>{t2}{t3}{t20}</div>;
    $[42] = t1;
    $[43] = t2;
    $[44] = t20;
    $[45] = t3;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== T0 || $[48] !== t21) {
    t22 = <T0>{t21}</T0>;
    $[47] = T0;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== T1 || $[51] !== t10 || $[52] !== t11 || $[53] !== t22 || $[54] !== t4 || $[55] !== t5 || $[56] !== t6 || $[57] !== t7 || $[58] !== t8 || $[59] !== t9) {
    t23 = <T1 opened={t4} onChange={t5} position={t6} withArrow={t7} shadow={t8} withinPortal={t9} closeOnClickOutside={t10}>{t11}{t22}</T1>;
    $[50] = T1;
    $[51] = t10;
    $[52] = t11;
    $[53] = t22;
    $[54] = t4;
    $[55] = t5;
    $[56] = t6;
    $[57] = t7;
    $[58] = t8;
    $[59] = t9;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  return t23;
};
export const QuestionAttachmentList = t0 => {
  const $ = _c(4);
  const {
    attachments,
    setFieldValue,
    className
  } = t0;
  let t1;
  if ($[0] !== attachments || $[1] !== className || $[2] !== setFieldValue) {
    t1 = notNullOrEmpty(attachments) ? <div className={twMerge("flex flex-col gap-2 group py-2", className)}>{attachments.map(a => <QuestionAttachmentItem key={a.path} attachment={a} editable={setFieldValue != null} onChange={n => setFieldValue?.(`${a.path}.name`, n)} onDelete={() => setFieldValue?.(a.path, null)} />)}</div> : undefined;
    $[0] = attachments;
    $[1] = className;
    $[2] = setFieldValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
type AttachmentButtonProps = {
  attachment: Attachment;
  editable: boolean;
  onDelete: () => void;
  onChange: (name: string) => void;
};

/** a link you can click on to download the file, fi readonly a little edit toggle button to change the name */
export const QuestionAttachmentItem = t0 => {
  const $ = _c(9);
  const {
    attachment: t1,
    editable,
    onDelete,
    onChange
  } = t0;
  const {
    name,
    path,
    type
  } = t1;
  const [editing, setEditing] = useState(false);
  const {
    uploadUrl
  } = useUpload();
  let t2;
  if ($[0] !== editable || $[1] !== editing || $[2] !== name || $[3] !== onChange || $[4] !== onDelete || $[5] !== path || $[6] !== type || $[7] !== uploadUrl) {
    t2 = <div className="flex items-center gap-4">{editing && isString(name) ? <><TextInput autoFocus={true} value={name} onChange={v => onChange(v.target.value)} className="flex-grow" styles={{
          input: {
            width: `${Math.max(name.length + 2, 12)}ch`,
            minWidth: "12ch"
          }
        }} /><ActionIcon><HiCheck onClick={() => setEditing(false)} /></ActionIcon></> : <div className="flex items-center gap-1"><a href={uploadUrl(path)} target="_new" download={true}><div className="flex items-center gap-2"><div className="flex items-center gap-2"><IconContext.Provider value={{
                size: "1.5em"
              }}>{match(type).with("application/pdf", _temp4).otherwise(_temp5)}</IconContext.Provider><div>{name}</div></div></div></a>{editable && <OverflowMenu className="group-hover:visible invisible" withinPortal={false}><Menu.Item leftSection={<HiPencil />} onClick={() => {
            setEditing(!editing);
          }}>Rename</Menu.Item><Menu.Item leftSection={<HiTrash />} onClick={() => {
            openConfirmModal({
              title: "Delete attachment?",
              centered: true,
              children: <p>Are you sure you want to delete the attachment:<b> {name} </b></p>,
              labels: {
                confirm: "Delete attachment",
                cancel: "Cancel"
              },
              confirmProps: {
                color: "red",
                variant: "filled"
              },
              onConfirm: async () => {
                onDelete();
              },
              zIndex: 300
            });
          }}>Delete</Menu.Item></OverflowMenu>}</div>}</div>;
    $[0] = editable;
    $[1] = editing;
    $[2] = name;
    $[3] = onChange;
    $[4] = onDelete;
    $[5] = path;
    $[6] = type;
    $[7] = uploadUrl;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
function _temp(r_0) {
  return r_0.error == null ? pick(r_0, ["name", "path", "type"]) : undefined;
}
function _temp2(r) {
  return r.map(_temp).filter(notNull);
}
function _temp3(t0) {
  const {
    path,
    type,
    name
  } = t0;
  return [path, {
    type,
    name
  }];
}
function _temp4() {
  return <PiFilePdfFill />;
}
function _temp5() {
  return <PiFileFill />;
}